module.exports = __webpack_public_path__ + "img/Plan 0-2 Rendering.d480595f.jpg";